import React, { useState } from 'react';

export const SearchInput = ({ value, onChange }) => {
  const [searchText, setSearchText] = useState(value);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onChange(searchText);
    }
  };

  return <div className="searchInput">
    <div className="nsw-form__input-group">
      <label className="sr-only" htmlFor="search-input">Search</label>
      <div className="searchInputField">
        <input
          type="text"
          name="search-input"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={handleKeyPress}
          className="nsw-form__input nsw-m-bottom-lg views-exposed-form"
        />
        <a
          href="#"
          className={'clear material-icons nsw-material-icons '+(searchText == '' ? ' clearHidden' : '')}
          aria-label="Clear search"
          onClick={e => {
            e.preventDefault();
            setSearchText('');
            onChange('');
          }}
        >
          close
        </a>
      </div>
      <button
        className="nsw-button nsw-button--dark"
        onClick={() => onChange(searchText)}
      >
        Search
      </button>
    </div>
  </div>
};
